import BaseClass from "../BaseClass.js";

import emojisJson from '../emojis.json';

export default class EmojisHandler extends BaseClass {

    constructor(element) {
        super(element);
        this.$twinInput = null;
        this.mainKeyListener = null;
        this.twinKeyListener = null;
        this.autoGrow = false;
        this.init();
    }


    init() {

        let mySelf = this;

        this.mainKeyListener = throttle(function (event) {
            mySelf.handleInput(mySelf.$element, mySelf.$twinInput);
        }, 250);


        this.twinKeyListener = throttle(function (event) {
            mySelf.handleInput(mySelf.$twinInput, mySelf.$element);
        }, 250);

        this.$element.on('keyup', this.mainKeyListener);
        this.$element.on('change', this.mainKeyListener);


        // spiegelt die Eingabe des derzeitigen Input-Feldes mit dem aus der twin-id
        let twinInputID = this.$element.attr('data-twin-id');
        if (twinInputID != undefined) {

            this.$twinInput = $('#' + twinInputID).first();

            if (this.$twinInput.length == 1) {
                if (this.$twinInput.val().length > 0) {
                    this.$element.val(this.$twinInput.val());
                }
                this.$twinInput.on('keyup', this.twinKeyListener);
                this.$twinInput.on('change', this.twinKeyListener);
            }
        }

        let autoGrow = this.$element.attr('data-autogrow');
        if (autoGrow != undefined && autoGrow == "true") {
            this.autoGrow = true;
        }

        this.inputAutoGrow();
    }

    handleInput($inputElement, $twinElement) {
        let message = $inputElement.val();
        message = this.replaceEmojiCodesWithEmoji(message);
        $inputElement.val(message);
        if ($twinElement != null) {
            $twinElement.val(message);
        }

        this.inputAutoGrow();

    }


    inputAutoGrow(){
        if(this.autoGrow){
            this.element.parentNode.dataset.replicatedValue = this.element.value;
        }
    }


    replaceEmojiCodesWithEmoji(message) {

        return message.split(' ').map(function (piece) {

            if (emojisJson[piece] != undefined) {
                let emoji = emojisJson[piece][0];
                return emoji;
            }
            return piece;
        }).join(' ');
    };


    destroyListener() {
        this.$element.off('keyup', this.mainKeyListener);
        this.$element.off('change', this.mainKeyListener);

        if (this.$twinInput != null) {
            this.$twinInput.off('keyup', this.twinKeyListener);
            this.$twinInput.off('change', this.twinKeyListener);
        }
    }
}